/**
 * Chuỗi hiển thị của menu "Bảng điện tử công cộng" (lịch phát, thiết bị, ba trang nhật ký) — dùng API `/api/v1/digital-signage/*` tách khỏi cụm loa.
 */
export const viBangTin = {
  chung: {
    stt: 'STT',
    thaoTac: 'Thao tác',
    diaBan: 'Địa bàn',
    toanTinh: 'Toàn tỉnh',
    timDiaBan: 'Tìm địa bàn…',
    tatCa: 'Tất cả',
    huy: 'Hủy',
    dong: 'Đóng',
    luu: 'Lưu',
    quayLai: 'Quay lại',
    tiepTuc: 'Tiếp tục',
    dangLuu: 'Đang lưu…',
    dangGui: 'Đang gửi…',
    xuatExcel: 'Xuất Excel',
    dangXuat: 'Đang xuất…',
    xuatXong: 'Đã xuất {so} dòng ra tệp Excel.',
    xuatRong: 'Không có dòng nào khớp bộ lọc để xuất.',
    xuatVuotGioiHan: 'Có {tong} dòng khớp bộ lọc; tệp chỉ chứa {so} dòng đầu (giới hạn {gioiHan}).',
    xuatLoi: 'Xuất Excel không thành công: {loi}',
    tuKhoa: 'Từ khoá',
    tim: 'Tìm',
    timKiem: 'Tìm kiếm',
    khongCo: '—',
    loiThaoTac: 'Thao tác không thành công: {loi}',
    ketQuaGui: 'Mã phiên: {phien}.',
    ketQuaGuiCoLoi: 'Đã gửi lệnh (mã phiên {phien}) nhưng có {so} lỗi: {chiTiet}',
    giay: '{so} giây',
  },

  loaiBanTin: {
    '1': 'Bản tin văn bản (giọng đọc)',
    '2': 'Bản tin hình ảnh',
    '3': 'Bản tin âm thanh',
    '4': 'Bản tin video',
    '5': 'Khác',
  } as Record<string, string>,
  vungPhat: {
    '0': 'Toàn màn hình',
    '1': 'Vùng thông báo',
    '2': 'Vùng bên trái',
    '3': 'Vùng bên phải',
  } as Record<string, string>,
  mucDoUuTien: { '1': 'Khẩn cấp', '2': 'Ưu tiên', '3': 'Thông thường' } as Record<string, string>,
  phanVungManHinh: { '0': 'Toàn màn hình', '1': 'Phân vùng màn hình' } as Record<string, string>,
  trangThaiBanTin: {
    tao_moi: 'Tạo mới',
    chua_duyet: 'Chờ duyệt',
    da_duyet: 'Đã duyệt',
    dang_phat: 'Đang phát',
    da_phat: 'Đã phát',
    da_huy: 'Đã hủy',
  } as Record<string, string>,
  trangThaiLich: { hieu_luc: 'Còn hiệu lực', het_hieu_luc: 'Hết hiệu lực', da_huy: 'Đã hủy' } as Record<
    string,
    string
  >,
  nguonKichHoat: {
    lich: 'Theo lịch',
    phat_ngay: 'Phát ngay',
    khan_cap: 'Khẩn cấp',
    trung_uong: 'Trung ương',
  } as Record<string, string>,

  /* ------------------------------------ Bản tin ------------------------------------ */
  /**
   * Bản tin dùng chung Kho nội dung (hợp đồng gộp kho 29/10/2026) — trang "Bản tin điện tử" riêng
   * đã bỏ; ở đây chỉ còn chuỗi của ô chọn địa bàn và popup xem tệp dùng chung.
   */
  banTin: {
    chonXa: 'Chọn xã, phường',
    daChonXa: 'Đã chọn {so} xã, phường',
    chonTatCa: 'Chọn tất cả',
    boChon: 'Bỏ chọn',
    timXa: 'Tìm xã, phường…',
    dangTaiTep: 'Đang tải tệp…',
  },

  /* ------------------------------------ Lịch phát ------------------------------------ */
  lich: {
    tieuDe: 'Lịch phát bảng tin',
    themMoi: 'Thêm mới lịch',
    tenLich: 'Tên lịch phát',
    nhapTenLich: 'Nhập tên hoặc mã lịch',
    trangThai: 'Trạng thái',
    chonTrangThai: 'Tất cả trạng thái',
    rongMoTa: 'Chưa có lịch phát bảng tin nào. Bắt đầu bằng cách thêm mới lịch.',
    cot: {
      ten: 'Tên lịch phát',
      loai: 'Kiểu lịch',
      phanVung: 'Phân vùng màn hình',
      thoiGian: 'Thời gian phát',
      soBanTin: 'Số bản tin',
      diaBan: 'Địa bàn',
      trangThai: 'Trạng thái',
      nguoiTao: 'Người tạo',
    },
    loaiLich: { theo_ngay: 'Theo ngày', hang_ngay: 'Hằng ngày' } as Record<string, string>,
    ma: 'Mã lịch: {ma}',
    sua: 'Sửa',
    phat: 'Phát lịch',
    dangPhat: 'Đang phát…',
    huy: 'Hủy lịch',
    huyTieuDe: 'Hủy lịch phát bảng tin',
    huyHeQua: 'Lịch "{ten}" sẽ bị hủy và gửi lệnh hủy (DV012) tới {soDiaBan} địa bàn nhận lịch.',
    lyDoHuy: 'Lý do hủy',
    daHuy: 'Đã hủy lịch "{ten}".',
    daPhat: 'Đã gửi lại lịch "{ten}" xuống thiết bị.',
    soKhungGio: '{so} khung giờ',

    /* Soạn — bố cục như trang "Lịch phát thanh"; chuỗi chung lấy từ `viLichPhatThanh`. */
    phanVungManHinh: 'Phân vùng màn hình',
    daLuu: 'Đã lưu {so} lịch phát bảng tin.',
    daLuuTen: 'Đã lưu lịch phát "{ten}".',
    daCapNhat: 'Đã cập nhật lịch phát "{ten}".',
    daLuuMot: 'Đã lưu {so}/{tong} lịch trước khi gặp lỗi.',
    cotBanTin: { loai: 'Loại bản tin', vungPhat: 'Vùng phát' },
  },

  /* ------------------------------------ Thiết bị ------------------------------------ */
  /* Hộp "Phát khẩn cấp" (nút Phát ngay của trang Bảng điện tử) — DV011, chọn nhiều bản tin. */
  khanCap: {
    tieuDe: 'Phát khẩn cấp',
    dong: 'Đóng',
    chonVungPhat: 'Chọn vùng phát:',
    loaiBanTin: 'Loại bản tin:',
    loaiNhan: {
      video: 'Bản tin video',
      'hinh-anh': 'Bản tin hình ảnh',
      'am-thanh': 'Bản tin âm thanh',
    } as Record<string, string>,
    phatKhanCap: 'Phát khẩn cấp',
    dangGui: 'Đang gửi…',
    xoaTatCa: 'Xóa tất cả',
    khoBanTin: 'Bản tin trong kho',
    daChon: 'Bản tin đã chọn',
    cot: { stt: 'STT', tieuDe: 'Tiêu đề', thoiLuong: 'Thời lượng', xemLai: 'Xem lại', vungPhat: 'Vùng phát' },
    them: 'Thêm',
    daThem: 'Đã thêm',
    themNhan: 'Thêm bản tin {tieuDe}',
    boNhan: 'Bỏ bản tin {tieuDe}',
    xemLaiNhan: 'Xem lại bản tin {tieuDe}',
    chuaXemDuoc: 'Chưa xem được bản tin "{tieuDe}" (chưa có tệp hoặc đang tải).',
    dangTai: 'Đang tải bản tin…',
    rong: 'Không có bản tin phù hợp.',
    trong: 'Trống',
    tong: 'Tổng {so} bản ghi',
    soTrang: 'Trang {trang}/{tong}',
    trangTruoc: 'Trang trước',
    trangSau: 'Trang sau',
    dichBang: 'Phát tới {so} bảng điện tử đã chọn: {ds}{them}',
    dichDiaBan: 'Phát tới mọi bảng điện tử thuộc {ten}',
    chuaCoDiaBan: 'Chưa xác định được địa bàn nhận — hãy chọn bảng điện tử hoặc địa bàn.',
    lyDoTuDong: 'Phát khẩn cấp {so} bản tin — {dich}',
    loi: 'Không phát được: {loi}',
  },

  thietBi: {
    tieuDe: 'Bảng điện tử',
    timGoiY: 'Tên hoặc mã bảng điện tử',
    rongMoTa: 'Chưa có bảng điện tử nào trong phạm vi địa bàn đang xem.',
    cot: {
      ten: 'Tên bảng điện tử',
      diaBan: 'Địa bàn',
      ketNoi: 'Kết nối',
      trangThai: 'Màn hình',
      noiDung: 'Nội dung đang phát',
      capNhat: 'Cập nhật lúc',
    },
    ma: 'Mã: {ma}',
    dangKetNoi: 'Đang kết nối',
    matKetNoi: 'Mất kết nối',
    dangMo: 'Đang mở',
    dangTat: 'Đang tắt',
    khongRo: 'Chưa rõ',
    chonDong: 'Chọn {ten}',
    daChon: 'Đã chọn {so} bảng điện tử',
    phatNgay: 'Phát ngay',
    phatKhanCap: 'Phát khẩn cấp',
    dieuKhien: 'Điều khiển',
    tieuDeMenuDieuKhien: 'Lệnh điều khiển bảng điện tử (DV017)',
    chiTiet: 'Chi tiết',
    canChon: 'Chọn ít nhất một bảng điện tử hoặc một địa bàn.',

    /* Danh sách theo mẫu trang Cụm loa (chuỗi chung ở `viThietBi.danhSach`) */
    trangThaiLoc: {
      dang_ket_noi: 'Đang kết nối',
      dang_phat: 'Đang phát',
      mat_ket_noi: 'Mất kết nối',
    } as Record<string, string>,
    maNccGoiY: 'Nhập mã nhà cung cấp',
    chuaCoLich: 'chưa có lịch',
    lichChuaCapNhat: 'Lịch phát chưa cập nhật',
    amLuongKhongBao:
      'Bảng chưa báo âm lượng (CV276 không có trường này; hệ thống đọc ThongTinThietBi.AmLuong nếu bảng gửi)',

    /* Hộp phát */
    phatNgayTieuDe: 'Phát ngay bản tin',
    phatKhanCapTieuDe: 'Phát khẩn cấp bản tin',
    banTin: 'Bản tin (đã duyệt)',
    chonBanTin: 'Chọn bản tin',
    phanVung: 'Phân vùng màn hình',
    diaBanNhan: 'Địa bàn nhận',
    thietBiNhan: 'Bảng điện tử nhận: {so}',
    thietBiNhanTatCa: 'Mọi bảng điện tử trên địa bàn nhận',
    lyDo: 'Lý do phát khẩn cấp',
    lyDoBatBuoc: 'Vui lòng nhập lý do phát khẩn cấp.',
    canBanTin: 'Vui lòng chọn bản tin.',
    ghiChuKhanCap:
      'Phát ngay (= phát khẩn cấp, CV276 DV011): bảng dừng nội dung đang phát, phát ngay bản tin này, rồi quay lại lịch đã lập (lịch không bị hủy).',
    lyDoTuDong: 'Phát ngay bản tin "{tieuDe}"',
    gui: 'Gửi',
    daPhatNgay: 'Đã gửi lệnh phát ngay.',
    daPhatKhanCap: 'Đã gửi lệnh phát khẩn cấp.',
    daDieuKhien: 'Đã gửi lệnh điều khiển.',

    /* Hộp điều khiển */
    dieuKhienTieuDe: 'Điều khiển bảng điện tử ({so})',
    lenh: 'Lệnh',
    lenhNhan: {
      '0': 'Âm lượng',
      '2': 'Dừng / tạm dừng / phát tiếp',
      '3': 'Khởi động lại',
      '4': 'Nâng cấp phần mềm',
    } as Record<string, string>,
    amLuong: 'Âm lượng (0–100)',
    amLuongLoi: 'Âm lượng phải là số nguyên từ 0 đến 100.',
    kieuDung: 'Thao tác phát',
    kieuDungNhan: {
      '0': 'Dừng tất cả',
      '1': 'Bỏ qua bản đang phát',
      '2': 'Tạm dừng',
      '3': 'Phát tiếp',
    } as Record<string, string>,
    treKhoiDong: 'Khởi động lại sau (giây)',
    treLoi: 'Số giây phải là số nguyên không âm.',
    urlNangCap: 'Đường dẫn tệp nâng cấp (URL)',
    urlLoi:
      'Đường dẫn phải bắt đầu bằng http:// hoặc https:// và dài tối đa 50 ký tự (giới hạn ThamSo CV276).',
  },

  /* ------------------------------------ Nhật ký ------------------------------------ */
  nhatKy: {
    phat: {
      tieuDe: 'Nhật ký bản tin đã phát',
      rongMoTa: 'Chưa có bản tin nào được bảng điện tử báo đã phát.',
      tenTep: 'nhat-ky-ban-tin-da-phat.xlsx',
    },
    lich: {
      tieuDe: 'Nhật ký lịch phát thiết bị',
      rongMoTa: 'Chưa có bảng điện tử nào báo đã nhận lịch phát.',
      tenTep: 'nhat-ky-lich-phat-bang-tin.xlsx',
    },
    huy: {
      tieuDe: 'Nhật ký hủy lịch phát',
      rongMoTa: 'Chưa có bảng điện tử nào báo đã hủy lịch phát.',
      tenTep: 'nhat-ky-huy-lich-bang-tin.xlsx',
    },
    timGoiY: 'Nhập tên, mã lịch hoặc bản tin',
    cot: {
      banTin: 'Bản tin',
      loai: 'Loại',
      vungPhat: 'Vùng phát',
      thietBi: 'Bảng điện tử',
      diaBan: 'Địa bàn',
      batDau: 'Thời điểm bắt đầu',
      thoiLuong: 'Thời lượng',
      nguon: 'Nguồn kích hoạt',
      lich: 'Lịch phát',
      thoiDiemNhan: 'Thời điểm nhận',
      thoiDiemHuy: 'Thời điểm hủy',
      xemLai: 'Xem lại',
    },
    xem: 'Xem',
    xemNhan: 'Xem lại tệp của bản tin {ten}',
    khongCoTep: 'Không lấy được tệp để xem lại.',
    dongY: 'Đóng',
  },
};

export type ViBangTin = typeof viBangTin;
